module.exports = "/images/laser tag (Union selection-working).svg?67109f52b173b60bdefca13adbeec8b3";